import React from "react";
import { Grid } from "@mui/material";

/**
 * @typedef {Object} CustomColProps
 * @property {React.ReactNode} children
 * @property {SxProps<Theme>} sx
 * @property {ResponsiveStyleValue<GridSize>} size
 */

/**
 * @param {CustomColProps} param0
 * @returns {JSX.Element} Dropdown component
 */
const Col = ({ children, ...props }) => {
  return (
    <Grid item {...props} sx={{ paddingInline: "5px", ...props.sx }}>
      {children}
    </Grid>
  );
};

export default Col;
